import React from 'react'
import LandingPage from "./pages/landingPage"

export default function App() {
  return (
    <div>
      <LandingPage/>
    </div>
  )
}
